import { FieldDefinition } from '../../../App/apiWrapper';
import { FieldIndex } from '../index';

export const getUiFieldIndices = (fieldDefinition: FieldDefinition, fieldIndices: FieldIndex[]): FieldIndex[] => {
  const idxVar = fieldDefinition.forEach ? fieldDefinition.forEach.uiIdxVar : null;
  return idxVar ? fieldIndices : [];
};
